import React from 'react'
import styled from 'styled-components'
import {
  ContentHeader,
  ContentTitle
} from 'components/Content'
import ElementContentIcon from './ContentIcon'

const StyledContentHeader = styled(ContentHeader)``

const StyledElementContentIcon = styled(ElementContentIcon)`
  ${StyledContentHeader}:hover & {
    color: inherit;
  }
`

const StyledContentTitle = styled(ContentTitle)`
  ${StyledContentHeader}:hover & {
    color: inherit;
  }
`

type Props = React.ComponentProps<typeof StyledContentHeader> & {
  icon: React.ReactNode
}

const AddElementButton: React.FC<Props> = ({ children, icon, ...restProps }) => {
  return (
    <StyledContentHeader
      {...restProps}
    >
      <StyledElementContentIcon>
        {icon}
      </StyledElementContentIcon>
      <StyledContentTitle>
        {children}
      </StyledContentTitle>
    </StyledContentHeader>
  )
}

export default AddElementButton
